import type { Component } from 'vue';
import IncidentTypeIconActionableObservation from './IncidentTypeIconActionableObservation.vue';
import IncidentTypeIconCapacityPerformance from './IncidentTypeIconCapacityPerformance.vue';
import IncidentTypeIconChangeOrConfigurationError from './IncidentTypeIconChangeOrConfigurationError.vue';
import IncidentTypeIconChemicalSpillEmissions from './IncidentTypeIconChemicalSpillEmissions.vue';
import IncidentTypeIconCoolingHVAC from './IncidentTypeIconCoolingHVAC.vue';
import IncidentTypeIconCustomerSatisfaction from './IncidentTypeIconCustomerSatisfaction.vue';
import IncidentTypeIconFacilityInfrastructure from './IncidentTypeIconFacilityInfrastructure.vue';
import IncidentTypeIconFireExplosion from './IncidentTypeIconFireExplosion.vue';
import IncidentTypeIconInformationSecurityCybersecurity from './IncidentTypeIconInformationSecurityCybersecurity.vue';
import IncidentTypeIconItSystemsNetwork from './IncidentTypeIconItSystemsNetwork.vue';
import IncidentTypeIconLegalRegulatory from './IncidentTypeIconLegalRegulatory.vue';
import IncidentTypeIconNetworkInfrastructure from './IncidentTypeIconNetworkInfrastructure.vue';
import IncidentTypeIconPeopleIncident from './IncidentTypeIconPeopleIncident.vue';
import IncidentTypeIconPhysicalInfrastructure from './IncidentTypeIconPhysicalInfrastructure.vue';
import IncidentTypeIconPhysicalSecurity from './IncidentTypeIconPhysicalSecurity.vue';
import IncidentTypeIconPolicyCompliance from './IncidentTypeIconPolicyCompliance.vue';
import IncidentTypeIconPositiveObservation from './IncidentTypeIconPositiveObservation.vue';
import IncidentTypeIconPowerElectricalSystems from './IncidentTypeIconPowerElectricalSystems.vue';
import IncidentTypeIconServiceQualityContractualDeviation from './IncidentTypeIconServiceQualityContractualDeviation.vue';
import IncidentTypeIconSupplierPerformance from './IncidentTypeIconSupplierPerformance.vue';
import IncidentTypeIconThirdParty from './IncidentTypeIconThirdParty.vue';
import IncidentTypeIconWasteManagement from './IncidentTypeIconWasteManagement.vue';

export const INCIDENT_TYPE_ICON_KEYS = [
    'actionable-observation',
    'positive-observation',
    'waste-management',
    'fire-explosion',
    'chemical-spill-emissions',
    'people-incident',
    'network-infrastructure',
    'facility-infrastructure',
    'capacity-performance',
    'change-or-configuration-error',
    'physical-infrastructure',
    'cooling-hvac',
    'power-electrical-systems',
    'customer-satisfaction',
    'legal-regulatory',
    'policy-compliance',
    'supplier-performance',
    'service-quality-contractual-deviation',
    'it-systems-network',
    'third-party',
    'information-security-cybersecurity',
    'physical-security',
] as const;

export type IncidentTypeIconKey = (typeof INCIDENT_TYPE_ICON_KEYS)[number];

export const INCIDENT_TYPE_ICON_COMPONENTS: Record<IncidentTypeIconKey, Component> = {
    'actionable-observation': IncidentTypeIconActionableObservation,
    'positive-observation': IncidentTypeIconPositiveObservation,
    'waste-management': IncidentTypeIconWasteManagement,
    'fire-explosion': IncidentTypeIconFireExplosion,
    'chemical-spill-emissions': IncidentTypeIconChemicalSpillEmissions,
    'people-incident': IncidentTypeIconPeopleIncident,
    'network-infrastructure': IncidentTypeIconNetworkInfrastructure,
    'facility-infrastructure': IncidentTypeIconFacilityInfrastructure,
    'capacity-performance': IncidentTypeIconCapacityPerformance,
    'change-or-configuration-error': IncidentTypeIconChangeOrConfigurationError,
    'physical-infrastructure': IncidentTypeIconPhysicalInfrastructure,
    'cooling-hvac': IncidentTypeIconCoolingHVAC,
    'power-electrical-systems': IncidentTypeIconPowerElectricalSystems,
    'customer-satisfaction': IncidentTypeIconCustomerSatisfaction,
    'legal-regulatory': IncidentTypeIconLegalRegulatory,
    'policy-compliance': IncidentTypeIconPolicyCompliance,
    'supplier-performance': IncidentTypeIconSupplierPerformance,
    'service-quality-contractual-deviation': IncidentTypeIconServiceQualityContractualDeviation,
    'it-systems-network': IncidentTypeIconItSystemsNetwork,
    'third-party': IncidentTypeIconThirdParty,
    'information-security-cybersecurity': IncidentTypeIconInformationSecurityCybersecurity,
    'physical-security': IncidentTypeIconPhysicalSecurity,
};

const INCIDENT_TYPE_ICON_KEY_SET = new Set<string>(INCIDENT_TYPE_ICON_KEYS);

export function isIncidentTypeIconKey(iconKey: string): iconKey is IncidentTypeIconKey {
    return INCIDENT_TYPE_ICON_KEY_SET.has(iconKey);
}
